import { EligibilityTypes } from '@/enums';

export const EXCESS_CODE_MAPPING =  Object.freeze([
  { code: '200000000', value: EligibilityTypes.SERVING },
  { code: '200000001', value: EligibilityTypes.EX_SERVING },
  { code: '200000002', value: EligibilityTypes.WORK_CONNECTION },
  { code: '200000003', value: EligibilityTypes.RELATED },
]);
